import React from 'react';
import clsx from 'clsx';
import { MoreHorizontal } from 'lucide-react';
import type { NavCategory } from './NavCategories';

const PRIMARY_TAB_IDS = ['home', 'life', 'household', 'finance', 'people'];

interface BottomTabBarProps {
  categories: NavCategory[];
  activeRouteCategoryId: string | null;
  onTabClick: (categoryId: string) => void;
  onMoreClick: () => void;
}

export const BottomTabBar: React.FC<BottomTabBarProps> = ({
  categories,
  activeRouteCategoryId,
  onTabClick,
  onMoreClick,
}) => {
  const primaryTabs = PRIMARY_TAB_IDS.map(id => categories.find(c => c.id === id)).filter(Boolean) as NavCategory[];

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 md:hidden bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800">
      <div className="flex items-stretch h-16">
        {primaryTabs.map((tab) => {
          const isActive = activeRouteCategoryId === tab.id;
          const Icon = tab.icon;

          return (
            <button
              key={tab.id}
              onClick={() => onTabClick(tab.id)}
              className={clsx(
                'flex-1 flex flex-col items-center justify-center gap-0.5 py-2 transition-all',
                isActive ? 'text-brand' : 'text-slate-400 hover:text-slate-600 dark:hover:text-slate-300'
              )}
            >
              <Icon className="w-5 h-5" />
              <span className="text-[10px] font-bold">{tab.label}</span>
              {isActive && <div className="w-1 h-1 rounded-full bg-brand mt-0.5" />}
            </button>
          );
        })}

        <button
          onClick={onMoreClick}
          className="flex-1 flex flex-col items-center justify-center gap-0.5 py-2 transition-all text-slate-400 hover:text-slate-600 dark:hover:text-slate-300"
        >
          <MoreHorizontal className="w-5 h-5" />
          <span className="text-[10px] font-bold">More</span>
        </button>
      </div>
    </div>
  );
};
